import { Cohort, PageId, PurchaseProductDuration } from '~/shared/constants'
import { useBulkSelector } from '~/shared/hooks/useBulkSelector'
import { useExperimentalFeatures } from '~/shared/hooks/useExperimentalFeatures'
import { usePageInfo } from '~/shared/providers/PageInfoProvider'
import { selectCurrentVariantCohort } from '~/shared/store/common'
import { selectUserStatus } from '~/shared/store/user'

const useSelectors = () =>
  useBulkSelector({
    userStatus: selectUserStatus,
    cohort: selectCurrentVariantCohort,
  })

export const useUserStatus = () => {
  const { userStatus, cohort } = useSelectors()
  const { isRecurringFirstUpsell } = useExperimentalFeatures()

  const {
    steps,
    currentSubscriptionPageId,
    currentUpsellPaywallPageId,
    activeUpsellPageIds,
  } = usePageInfo()

  const isSevenDaysSubscription =
    userStatus?.config.subscriptionDuration ===
    PurchaseProductDuration.SEVEN_DAY
  const shouldSkipUpsell =
    cohort === Cohort.MF_WATERFASTING_PRICEV2 ||
    cohort === Cohort.MF_INTRO_2_SET1
      ? false
      : isRecurringFirstUpsell && isSevenDaysSubscription

  if (userStatus?.account.hasAccount && userStatus?.hasSubscription) {
    return PageId.DOWNLOAD
  }

  if (
    (userStatus?.hasSubscription && !activeUpsellPageIds?.length) ||
    shouldSkipUpsell
  ) {
    return PageId.FINISHING_TOUCHES
  }

  if (userStatus?.hasSubscription && activeUpsellPageIds?.length) {
    return currentUpsellPaywallPageId
  }

  if (userStatus?.email.hasEmail && !userStatus?.hasSubscription) {
    return currentSubscriptionPageId || steps[0].id
  }

  return '' as PageId
}
